
import { SysGlobals } from '../framework/sysglobals';
import { InputBoxDialogComponent } from '@m4u-angular/ui/dialogs/inputbox-dialog/inputboxdialog.component';
import { Component, ViewChild } from '@angular/core';

import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { SystemEndpoint } from '../endpoints/system.endpoint';

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-mid-store',
    templateUrl: './mid-store.component.html'
})
export class MidStoreComponent extends BasePageComponent<BaseEntity, BaseState> {

    constructor(A: ServiceBagService,
        private systemEndpoint: SystemEndpoint) {
        super(A, ' MidStoreComponent', BaseEntity, BaseState);
    }
    @ViewChild(InputBoxDialogComponent) inputBoxDialog: InputBoxDialogComponent;

    override OnInitComponentFinishedInternal() {
        this.inputBoxDialog.ShowDialogShort((value: string) => {
            this.Do(this.systemEndpoint.StoreMID(value), false, () => { this.Navigate(['/system/login'], { Language: SysGlobals.Language })})
        }, () => this.Navigate(['/system/login'], { Language: SysGlobals.Language }));
    }

}
